import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    publicKey: null,
    casperChainConfig: null,
    isCasperConnected: false,
    casperWalletName: "casper-wallet", // Default wallet name
    casperActiveAccount: null, // Active account from Casper wallet
};

export const casperSlice = createSlice({
    name: "casper",
    initialState,
    reducers: {
        setCasperPublicKey: (state, action) => {
            state.publicKey = action.payload;
        },
        setCasperChainConfig: (state, action) => {
            state.casperChainConfig = action.payload;
        },
        resetCasper: (state) => {
            state.publicKey = null;
            state.casperChainConfig = null;
        },
        setCasperActiveAccount: (state, action) => {
            state.casperActiveAccount = action.payload;
        },
    },
});

export const {
    setCasperPublicKey,
    setCasperChainConfig,
    resetCasper,
    casperActiveAccount,
    setCasperActiveAccount,
} = casperSlice.actions;

export default casperSlice.reducer;
